<template>
    <span v-if="hasText" class="select-tag" :style="pillStyle">
        <span v-if="dot" class="select-tag__dot" :style="dotStyle"></span>
        <span class="select-tag__text">{{ text }}</span>
    </span>
</template>

<script>
import { resolveTagColor } from "@/components/common/mini-table/cells/selectTagColor";

export default {
    name: "SelectTag",
    props: {
        text: {
            type: [String, Number],
            default: ""
        },
        color: {
            type: String,
            default: ""
        },
        dot: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        hasText() {
            return this.text !== null && this.text !== undefined && ('' + this.text).trim() !== "";
        },
        resolved() {
            return resolveTagColor(this.color);
        },
        pillStyle() {
            return {
                backgroundColor: this.resolved.bg,
                color: this.resolved.fg
            };
        },
        dotStyle() {
            return {
                backgroundColor: this.resolved.dot
            };
        }
    }
}
</script>

<style scoped>
.select-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;
    max-width: 100%;
}

.select-tag__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    flex: 0 0 auto;
}

.select-tag__text {
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
